
import { useState, useEffect } from "react";

// Integration logos as SVG components
function StripeLogo() {
  return (
    <svg viewBox="0 0 60 25" className="h-6 md:h-8 w-auto">
      <path
        fill="currentColor"
        d="M59.64 14.28h-8.06v-1.4h8.06v1.4zm0-3.07h-8.06v-1.4h8.06v1.4zm-18.3 7.09c-1.29 0-2.13-.54-2.13-1.88 0-1.34.83-1.87 2.13-1.87h1.66v-1.37h-1.66c-2.12 0-3.87 1.17-3.87 3.25s1.75 3.25 3.87 3.25h1.66v-1.38h-1.66zm3.06-7.09v-1.4h5.19v1.4h-5.19zm-1.74 0h-1.72v-1.4H31.5V5.18h-1.74v8.75c0 1.62 1.11 2.78 2.73 2.78h1.06v-1.38h-1.06c-.77 0-1.37-.56-1.37-1.4v-2.8h1.74zm-5.03-1.4h1.73v8.81h-1.73V9.81zm8.5 8.81V15.5c0-1.5 1.11-2.24 2.34-2.24 1.22 0 2.33.74 2.33 2.24v3.12h1.72V15.5c0-2.43-1.9-3.59-4.05-3.59-2.15 0-4.06 1.16-4.06 3.59v3.12h1.72zm-8.5-13.82c.77 0 1.4-.62 1.4-1.4 0-.77-.63-1.4-1.4-1.4-.78 0-1.4.63-1.4 1.4 0 .78.62 1.4 1.4 1.4zm-4.67 5.01v-1.4h8.87v1.4h-8.87zm-8.58 0h1.72v8.81h-1.72V9.81zm0-3.5h1.72v1.9h-1.72v-1.9zm-7.32 0h1.73v10.7h-1.73v-1.36c-.89 1.13-2.37 1.7-3.76 1.7-1.34 0-2.57-.52-3.39-1.45-.82-.93-1.27-2.12-1.27-3.54 0-1.43.47-2.67 1.26-3.6.8-.92 2.12-1.45 3.4-1.45 1.38 0 2.86.57 3.76 1.73V6.3zm-3.75 9.57c2.05 0 3.75-1.67 3.75-3.72S13.11 8.43 11.04 8.43c-2.08 0-3.75 1.66-3.75 3.72s1.67 3.72 3.74 3.72zm38.99 1.7c-1.22 0-2.25-.21-3.05-.61-.39-.19-.52-.67-.26-1.01l.38-.5c.23-.3.68-.38 1.01-.17.54.32 1.23.48 1.92.48 1.44 0 2.15-.56 2.15-1.35 0-.3-.15-.55-.44-.76-.29-.2-.72-.32-1.29-.4l-.9-.12c-.77-.1-1.37-.26-1.9-.47-.52-.21-.97-.52-1.3-.92-.33-.4-.5-.92-.5-1.55 0-1.66 1.4-2.82 3.71-2.82.93 0 1.75.18 2.45.53.39.19.52.67.27 1.01l-.36.48c-.23.3-.68.39-1.01.19-.44-.24-.97-.36-1.35-.36-1.3 0-1.89.5-1.89 1.22 0 .23.08.43.25.6.16.17.4.3.71.4.31.1.71.18 1.2.25l.76.1c.73.1 1.36.25 1.9.45.55.2 1.01.5 1.37.91.36.41.54.96.54 1.64 0 .83-.32 1.57-.9 2.09-.58.51-1.46.81-2.47.81"
      />
    </svg>
  );
}

function QuickBooksLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 md:h-7 w-auto">
      <path
        fill="currentColor"
        d="M22.5 10.516a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zM11.763 4.982c-.989 0-1.979.165-2.967.495-.4.165-.66.66-.66 1.154v6.595c0 .164.165.33.33.33h2.968c3.462 0 5.77-2.145 5.77-4.455.164-2.31-2.144-4.119-5.44-4.119zm-.33 6.43h-.989c-.165 0-.33-.164-.33-.33v-3.13c0-.164.165-.33.33-.33h.99c1.318 0 2.309.66 2.309 1.815 0 1.32-.99 1.98-2.31 1.98z"
      />
      <path
        fill="currentColor"
        d="M11.598 6.962h-.66c-.33 0-.659.33-.659.66v1.978c0 .33.33.66.66.66h.659c.99 0 1.648-.495 1.648-1.648 0-.989-.66-1.65-1.648-1.65zm1.48-4.95H5.992c-.825 0-1.485.66-1.485.99v9.076c0 .33.33.66.66.66H6c.33 0 .66-.33.66-.66V6.302c0-.33.33-.66.66-.66h5.759c.33 0 .66-.33.66-.66v-.33c0-.825-.66-1.65-1.65-1.65zm-4.95 12.54c0-.825-.66-1.484-1.484-1.484-.825 0-1.485.66-1.485 1.484 0 .825.66 1.484 1.485 1.484.825.165 1.484-.66 1.484-1.484zm15.057-2.639H15.06c-.826 0-1.485.66-1.485 1.485v6.436c0 .33.33.66.66.66h.825c.33 0 .66-.33.66-.66v-5.776c0-.33.33-.66.66-.66h5.759c.33 0 .66-.33.66-.66v-.33c0-.66-.495-1.485-1.153-1.485zm-4.95 7.918c0-.824-.66-1.484-1.484-1.484-.825 0-1.485.66-1.485 1.484 0 .825.66 1.484 1.485 1.484.825.165 1.484-.66 1.484-1.484z"
      />
    </svg>
  );
}

function GoogleAnalyticsLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-6 md:h-8 w-auto">
      <path
        fill="currentColor"
        d="M6 17.25l.365-.365 7.385-7.385L6 17.25zm4.5-15.75a1.5 1.5 0 00-1.5 1.5v10.5a1.5 1.5 0 001.5 1.5h1.5v3h1.5v-3h1.5a1.5 1.5 0 001.5-1.5v-10.5a1.5 1.5 0 00-1.5-1.5h-4.5zm0 9v-7.5h4.5v7.5h-4.5zm8.768-.268l-2.475 2.475a.375.375 0 000 .53l4.5 4.5a.375.375 0 00.53 0l2.475-2.475a1.5 1.5 0 000-2.12l-2.915-2.915a1.5 1.5 0 00-2.115.005zm.866 3.147l-1.326 1.326-1.326-1.326 1.326-1.326 1.326 1.326z"
      />
    </svg>
  );
}

function MetaLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-6 md:h-8 w-auto">
      <path
        fill="currentColor"
        d="M12 1.892c-5.651 0-9 2.884-9 8.25 0 2.886 1.108 4.758 2.845 6.188C7.49 17.623 8.48 17.917 10 18.25v-3.25H8V13h2v-1.47c0-2.42 1.436-3.53 3.426-3.53.991 0 1.574.073 1.824.106v2.394h-1.444c-.981 0-1.2.466-1.2 1.59V13h2.5l-.5 2h-2v3.223c1.337-.339 2.214-.613 3.067-1.346C18.51 15.505 19 13.959 19 10.142c0-5.376-3.343-8.25-7-8.25z"
      />
    </svg>
  );
}

function HubspotLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 md:h-7 w-auto">
      <path
        fill="currentColor"
        d="M19.882 14.764c-.391.7-.929 1.307-1.573 1.784a11.713 11.713 0 002.192.26 11.792 11.792 0 00-.619-2.046v.002zm-3.536 2.388a8.536 8.536 0 01-4.348-.012 3.398 3.398 0 01-.569 1.082 9.972 9.972 0 005.498.006 3.393 3.393 0 01-.581-1.076zm-4.923-.106a2.925 2.925 0 01-2.12-.861 2.924 2.924 0 01-.862-2.121 2.89 2.89 0 01.874-2.107 2.89 2.89 0 012.108-.874c.79 0 1.563.323 2.118.878a2.958 2.958 0 01.5 3.321 1.73 1.73 0 01-.674-.561 1.547 1.547 0 01-.367-1.001 1.51 1.51 0 01.457-1.081 1.51 1.51 0 011.08-.458c.364 0 .72.146.979.405.259.258.404.613.404.978a1.55 1.55 0 01-1.513 1.539 3.38 3.38 0 01-.984 1.943zm-1.756-8.976a11.712 11.712 0 00-2.192-.26c.226.665.425 1.352.618 2.046.392-.7.93-1.305 1.574-1.784v-.002zm2.179-.142a8.536 8.536 0 014.348.012c.144-.376.344-.744.57-1.082a9.972 9.972 0 00-5.499-.006c.254.323.445.69.581 1.076zm-3.177 1.475a3.364 3.364 0 00-.939.726c-.275.273-.484.593-.62.94a10.79 10.79 0 01-.798-2.698c.782.079 1.553.27 2.275.561l.082.471zm-2.592 6.156c.137.35.346.67.621.943.25.248.544.444.864.58-.725.291-1.493.478-2.272.552a11.943 11.943 0 01.787-2.073v-.002zm8.626-5.441a9.062 9.062 0 00-.082-.471 7.432 7.432 0 012.276-.561c-.16.887-.421 1.803-.797 2.696-.137-.347-.345-.667-.618-.94a3.354 3.354 0 00-.779-.724zm.78 6.965c.32-.136.614-.332.863-.58.275-.274.484-.594.621-.943a10.79 10.79 0 01.787 2.073 8.632 8.632 0 01-2.272-.55zm3.108-8.919a10.65 10.65 0 00-2.649-.307c-.2 0-.392.007-.586.018a4.361 4.361 0 00-1.656-1.576 11.876 11.876 0 00-5.339 0C6.728 1.42 5.492 2.228 5 3.359c-.918.043-1.798.205-2.649.529a11.763 11.763 0 00.307 12.058c.84.3 1.741.442 2.649.307.2 0 .392-.007.586-.018a4.361 4.361 0 001.656 1.576 11.876 11.876 0 005.339 0c1.268-.503 2.306-1.31 2.798-2.442a9.18 9.18 0 002.649-.307 11.714 11.714 0 00-.307-12.058z"
      />
    </svg>
  );
}

function ShopifyLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 md:h-7 w-auto">
      <path
        fill="currentColor"
        d="M15.337 22.28l7.331-1.609s-2.67-18.039-2.667-18.056c-.005-.017-.021-.023-.029-.034a.362.362 0 00-.079-.101c-.303-.28-1.047-.538-2.374-.784-.868-.157-1.854-.29-2.933-.394-.296-.951-.832-1.839-1.566-2.449-.73-.605-1.564-.846-2.389-.847-1.066-.001-1.897.428-2.467.798a4.17 4.17 0 00-.672.573 7.399 7.399 0 00-.333.359 9.419 9.419 0 00-.479.594c-.278.369-.514.724-.657.943-.47.026-.94.052-.137.08-.422.252-1.074.642-1.733 1.084-.66.444-1.301.94-1.726 1.364-.196.195-.348.375-.476.541a2.345 2.345 0 00-.236.458l-.059.174c-.372 1.114-7.599 22.851-7.599 22.851l19.5 3.386 8.891-2.184-2.677-1.273zm-.216-.368l-7.593 1.667-17.098-2.966 6.924-20.816.032-.105c.133-.324.355-.675.666-.799.31-.124 1.089-.284 1.089-.284s.827 2.325 3.56 2.325c2.734 0 3.365-2.364 3.365-2.364s1.36.077 2.295.225c.936.147 1.846.357 2.344.536 1.235.444 1.232.54 1.232.54l2.184 22.041zm-9.611-20.248c-.013.236-.401.483-.68.654-.28.171-.694.296-.694.296s-.512-.77-1.032-.77c-.874 0-.915.55-.915.688 0 .747 1.965 1.038 1.965 2.797 0 1.382-.875 2.277-2.055 2.277-1.416 0-2.14-882-2.14-882s.386-.21.584-.316c.198-.105 310-.194.31-.194.258 1.075.884 1.599 1.328 1.599.366 0 .519-.29.519-.504 0-.876-1.616-914-1.616-2.508 0-1.28.913-2.524 2.089-2.524 1.073 0 1.599.58 1.599.58l-.262 1.007zm-.212-.986c.102-.314.293-.712.633-.956a.642.642 0 01-.129.322v.003c-.147.198-.357.387-.504.63z"
      />
    </svg>
  );
}

function LinkedInLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 md:h-7 w-auto">
      <path
        fill="currentColor"
        d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
      />
    </svg>
  );
}

function TikTokLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 md:h-7 w-auto">
      <path
        fill="currentColor"
        d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.59-1.16-2.59-2.5 0-1.4 1.16-2.5 2.59-2.5.27 0 .53.04.77.12v-3.13c-.45-.1-.92-.14-1.42-.14-2.93 0-5.3 3.17-5.3 5.74 0 2.57 2.37 4.74 5.3 4.74 2.93 0 5.3-2.17 5.3-4.74V7.04c1.43 1.26 3.08 1.86 5.04 1.86v-3.08c-1.8 0-3.4-.96-4.03-2.81z"
      />
    </svg>
  );
}

function JiraLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 md:h-7 w-auto">
      <path
        fill="currentColor"
        d="M11.571 11.513H0a5.218 5.218 0 0 0 5.232 5.215h2.13v2.057A5.215 5.215 0 0 0 12.575 24V12.518a1.005 1.005 0 0 0-1.005-1.005zm5.723-5.756H5.736a5.215 5.215 0 0 0 5.215 5.214h2.129v2.058a5.218 5.218 0 0 0 5.215 5.214V6.758a1.001 1.001 0 0 0-1.001-1.001zM23.013 0H11.455a5.215 5.215 0 0 0 5.215 5.215h2.129v2.057A5.215 5.215 0 0 0 24 12.483V1.005A1.001 1.001 0 0 0 23.013 0z"
      />
    </svg>
  );
}

function AsanaLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 md:h-7 w-auto">
      <path
        fill="currentColor"
        d="M19.861 12.259a3.646 3.646 0 0 1-3.646 3.646 3.648 3.648 0 1 1 3.646-3.646zm-11.997 0a3.646 3.646 0 0 1-3.647 3.646A3.646 3.646 0 0 1 .57 12.259a3.648 3.648 0 1 1 7.294 0zm5.998 2.001a3.644 3.644 0 0 1 3.647-3.645 3.646 3.646 0 0 1-3.647 3.645z"
      />
    </svg>
  );
}

function TrelloLogo() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 md:h-7 w-auto">
      <path
        fill="currentColor"
        d="M19.2 3H4.8C3.81 3 3 3.81 3 4.8v14.4c0 .99.81 1.8 1.8 1.8h14.4c.99 0 1.8-.81 1.8-1.8V4.8c0-.99-.81-1.8-1.8-1.8zm-8.1 14.4c0 .495-.405.9-.9.9H5.4c-.495 0-.9-.405-.9-.9V5.4c0-.495.405-.9.9-.9h4.8c.495 0 .9.405.9.9v12zm8.1 0c0 .495-.405.9-.9.9h-4.8c-.495 0-.9-.405-.9-.9V5.4c0-.495.405-.9.9-.9h4.8c.495 0 .9.405.9.9v12z"
      />
    </svg>
  );
}

const logos = [
  <StripeLogo key="stripe" />,
  <QuickBooksLogo key="quickbooks" />,
  <GoogleAnalyticsLogo key="google-analytics" />,
  <MetaLogo key="meta" />,
  <HubspotLogo key="hubspot" />,
  <ShopifyLogo key="shopify" />,
  <LinkedInLogo key="linkedin" />,
  <TikTokLogo key="tiktok" />,
  <JiraLogo key="jira" />,
  <AsanaLogo key="asana" />,
  <TrelloLogo key="trello" />
];

export function IntegrationLogos() {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );
    
    const section = document.getElementById("integrations");
    if (section) {
      observer.observe(section);
    }
    
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section id="integrations" className="py-16 bg-white dark:bg-slate-950">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Seamless Integrations</h2>
          <p className="text-lg text-gray-600 dark:text-gray-400">
            Connect with all your favorite tools and services to centralize your data.
          </p>
        </div>
        
        <div className={`grid grid-cols-3 md:grid-cols-5 lg:grid-cols-7 gap-8 md:gap-12 justify-items-center items-center mt-12 transition-all duration-1000 ${
          isVisible ? "opacity-100" : "opacity-0"
        }`}>
          {logos.map((logo, index) => (
            <div
              key={index}
              className="text-gray-400 dark:text-gray-600 hover:text-gray-800 dark:hover:text-gray-200 transition-colors duration-300"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              {logo}
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-500 dark:text-gray-400">
            And many more integrations available...
          </p>
        </div>
      </div>
    </section>
  );
}
